/**
 * @fileoverview POST handler for the "/companies/:company_id/sender_verification/tracking_domains" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdSenderVerificationTrackingDomainsCacheKeys } from "./constants";
import type {
  PostCompaniesCompanyIdSenderVerificationTrackingDomainsProps,
  CompaniesCompanyIdSenderVerificationCreateTrackingDomainsResult,
} from "./types";

export const postCompaniesCompanyIdSenderVerificationTrackingDomains = reactQueryMutationAdapter(
  companiesCompanyIdSenderVerificationTrackingDomainsCacheKeys,
  (
    props: PostCompaniesCompanyIdSenderVerificationTrackingDomainsProps
  ): Promise<CompaniesCompanyIdSenderVerificationCreateTrackingDomainsResult> => {
    return fetch(
      `/companies/${props.company_id}/sender_verification/tracking_domains`,
      "POST",
      props,
      {},
      { propagateFetchRequestError: false }
    );
  }
);
